import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
} from "firebase/firestore";
import { db } from "../../../services/firebaseService/connection";
import logger from "../../../utils/logger";

export const deleteParentGiveaway = async (groupId, giveawayId) => {
  try {
    await deleteDoc(doc(db, "parentGroups", groupId, "giveaways", giveawayId));
    return { success: true, message: "Giveaway deleted successfully" };
  } catch (error) {
    logger.error("Error deleting giveaway:", error);
    return { success: false, message: "Failed to delete giveaway" };
  }
};

export const fetchGiveawayDetails = async (groupId, giveawayId) => {
  try {
    const giveawayRef = doc(
      db,
      "parentGroups",
      groupId,
      "giveaways",
      giveawayId,
    );
    const giveawaySnapshot = await getDoc(giveawayRef);
    return { success: true, data: giveawaySnapshot.data() };
  } catch (error) {
    return { success: false, message: "Failed to fetch giveaway details" };
  }
};

export const fetchParentGiveaways = async (groupId) => {
  try {
    const giveawaysRef = collection(db, `parentGroups`, groupId, `giveaways`);
    const giveawaysSnapshot = await getDocs(giveawaysRef);

    const giveaways = giveawaysSnapshot.docs.map((giveawayDoc) => {
      const giveawaysData = giveawayDoc.data();

      let status;
      if (giveawaysData.isDraft) {
        status = "Draft";
      } else if (giveawaysData.isLive) {
        status = "Live";
      } else if (giveawaysData.isCompleted) {
        status = "Closed";
      }

      const giveawayCloseDate =
        giveawaysData.winnersList && giveawaysData.winnersList.length > 0
          ? giveawaysData.winnersList.find(
              (item) => item.addedOn && item.addedOn > 0,
            )?.addedOn || ""
          : "";

      return {
        id: giveawayDoc.id,
        status: status,
        partnerId: giveawaysData?.partnerId,
        postDate: giveawaysData?.addedOn,
        closedDate: giveawayCloseDate,
        giveaway: giveawaysData?.itemName,
        winnersCount: giveawaysData?.quantity || 0,
        entrantsCount: giveawaysData?.noOfParticipants || 0,
        goalAmount: giveawaysData?.goalAmount || 0,
        receivedAmount: giveawaysData?.receivedAmount || 0,
        sponsor: {
          name: giveawaysData?.donatedByText,
          image: giveawaysData?.donatedByImage,
        },
        proceedsSupport: {
          name: giveawaysData?.proceedsSupportName,
          image: giveawaysData?.proceedsSupportImage,
        },
        winners:
          giveawaysData?.winnersList?.map((item) => ({
            name: item?.userName || "",
            image: item?.userImage || "",
          })) || [],
      };
    });

    giveaways.sort((a, b) => (b.postDate || 0) - (a.postDate || 0));
    return { success: true, data: giveaways };
  } catch (error) {
    return { data: [], success: false, message: "Failed to fetch giveaways" };
  }
};
